import http, { setLogoutHandler, setImpersonationTimeoutHandler } from './http';
import { getCsrfToken } from '../utils/csrf';
import { useAuthStore } from '../store/authStore';
import { getCurrentUser } from './userService';
import { toast } from 'react-hot-toast';

export async function logout(endpoint: string = '/api/auth/logout', skipAuth: boolean = false): Promise<void> {
    // Immediately disable the handler so any concurrent 401s during this logout
    // call the no-op instead of triggering a second logout.
    setLogoutHandler(async () => { });

    let redirectUrl = '/';

    try {
        const res = await http.post(
            endpoint,
            { _token: getCsrfToken() },
            {
                skipAuthInterceptor: skipAuth,
            },
        );
        redirectUrl = res?.data?.redirect_url || '/';
    } catch (error) {
        console.error('Logout failed', error);
    }

    // 1. Remove token
    localStorage.removeItem('token');

    // 2. Remove header
    delete http.defaults.headers.common['Authorization'];

    // 3. Clear Zustand
    const authStore = useAuthStore.getState();
    authStore.clearUser();
    authStore.setInitialized(true);

    // 4. Show toast
    toast.success('Logout successful');

    // 5. Redirect (backend controlled)
    window.location.href = redirectUrl;
}

// Register logout handler
setLogoutHandler(logout);

export async function handleImpersonationTimeout(): Promise<void> {
    try {
        const user = await getCurrentUser();
        const authStore = useAuthStore.getState();
        authStore.setUser(user);
        authStore.setInitialized(true);
    } catch (error) {
        console.error('Failed to refresh user after impersonation timeout', error);
    }

    toast('Your impersonation session timed out after inactivity. You have been returned to your own account.', {
        icon: '⏰',
        duration: 6000,
    });

    window.location.href = '/dashboard';
}

setImpersonationTimeoutHandler(handleImpersonationTimeout);
